//import $ from 'jquery';
import Param from '../../helpers/Param';
import AuthHeader from '../../helpers/AuthHeader';
import BuildQS from '../../helpers/BuildQS';
import config from '../../config/config';

export const spotifyDiscoveryService = {
	getSpotifyDiscovery,
	getSpotifyDiscoveryTotals,
	getSpotifyDiscoveryTimeseries,
	getSpotifyDiscoveryMainTimeseries,
	getSpotifyDiscoveryDetailsTimeseries,
};

function getSpotifyDiscovery(params){
	return config.live ? getSpotifyDiscoveryLive(params) : getSpotifyDiscoveryStatic();
}


function getSpotifyDiscoveryLive(params) {
	const requestOptions = {
		method: 'POST',
		headers: AuthHeader({'Content-Type': 'application/json'})
	};
	
	let baseUrl = config.apis.v3_data+'/simple',
		qs = BuildQS(params);
		
	qs.query_name = 'spotify_discovery_main';
	qs.active_milestones = true;
	qs.mode = 'table';
	
	qs.offset = params.page ? params.page*params.pageSize : 0;
	qs.row_limit = params.pageSize;
	
	let {sorted, filtered} = params;
	if(sorted !== undefined && sorted.length){
		sorted = sorted[0];
		qs.order_by = sorted.id;
		qs.order_dir = sorted.desc ? 'desc':'asc';
	}
	
	if(filtered !== undefined && filtered.length){
		for(let filter of filtered) {
			let value = filter.value;
			if(!value)
				continue;
			if(value instanceof Array) {
				value = value.join(',');
				if(!value)
					continue;
				qs[filter.id] = value;
			}
			else {
				qs[filter.id] = value;    
			}
		}            
	}

	
	//baseUrl += '?' + $.param(qs);
	requestOptions.body = JSON.stringify(qs);

	return fetch(baseUrl, requestOptions).then(res=>res.json());
}

function getSpotifyDiscoveryStatic() {
	let baseUrl = `${config.apis.sales}/api/static/spotify_discovery_main.json`;
	return fetch(baseUrl).then(res=>res.json());
}

function getSpotifyDiscoveryTotals(params){
	return config.live ? getSpotifyDiscoveryTotalsLive(params) : getSpotifyDiscoveryTotalsStatic();
}

function getSpotifyDiscoveryTotalsLive(params) {
	const requestOptions = {
		method: 'POST',
		headers: AuthHeader({'Content-Type': 'application/json'})
	};
	
	let baseUrl = config.apis.v3_data+'/simple',
		qs = BuildQS(params);
		
	qs.query_name = 'spotify_discovery_previous';
	qs.active_milestones = true;

	requestOptions.body = JSON.stringify(qs);

	return fetch(baseUrl, requestOptions).then(res=>res.json());
}

function getSpotifyDiscoveryTotalsStatic() {
	let baseUrl = `${config.apis.sales}/api/static/spotify_discovery_previous.json`;
	return fetch(baseUrl).then(res=>res.json());
}

function getSpotifyDiscoveryTimeseries(params){
	return config.live ? getSpotifyDiscoveryTimeseriesLive(params) : getSpotifyDiscoveryTimeseriesStatic();
}

function getSpotifyDiscoveryTimeseriesLive(params) {
	const requestOptions = {
		method: 'POST',
		headers: AuthHeader({'Content-Type': 'application/json'})
	};
	
	let baseUrl = config.apis.v3_data+'/simple',
		qs = BuildQS(params);
		
	qs.query_name = 'spotify_discovery_timeseries';
	qs.active_milestones = true;
	
	let {filtered} = params;
	if(filtered !== undefined && filtered.length){
		for(let filter of filtered) {
			let value = filter.value;
			if(!value)
				continue;
			if(value instanceof Array) {
				value = value.join(',');
				if(!value)
					continue;
				qs[filter.id] = value;
			}
			else {
				qs[filter.id] = value;    
			}
		}            
	}

	requestOptions.body = JSON.stringify(qs);

	return fetch(baseUrl, requestOptions).then(res=>res.json());
}

function getSpotifyDiscoveryTimeseriesStatic() {
	let baseUrl = `${config.apis.sales}/api/static/spotify_discovery_timeseries.json`;
	return fetch(baseUrl).then(res=>res.json());
}

function getSpotifyDiscoveryMainTimeseries(params){
	return config.live ? getSpotifyDiscoveryMainTimeseriesLive(params) : getSpotifyDiscoveryMainTimeseriesStatic();
}

function getSpotifyDiscoveryMainTimeseriesLive(params) {
	const requestOptions = {
		method: 'POST',
		headers: AuthHeader({'Content-Type': 'application/json'})
	};
	
	let baseUrl = config.apis.v3_data+'/simple',
		qs = BuildQS(params);
		
	qs.query_name = 'spotify_discovery_main';
	qs.active_milestones = true;
	qs.mode = 'timeseries';

	requestOptions.body = JSON.stringify(qs);

	return fetch(baseUrl, requestOptions).then(res=>res.json());
}

function getSpotifyDiscoveryMainTimeseriesStatic() {
	let baseUrl = `${config.apis.sales}/api/static/spotify_discovery_main_timeseries.json`;
	return fetch(baseUrl).then(res=>res.json());
}

function getSpotifyDiscoveryDetailsTimeseries(params){
	return config.live ? getSpotifyDiscoveryDetailsTimeseriesLive(params) : getSpotifyDiscoveryDetailsTimeseriesStatic();
}

function getSpotifyDiscoveryDetailsTimeseriesLive(params) {
	const requestOptions = {
		method: 'POST',
		headers: AuthHeader({'Content-Type': 'application/json'})
	};
	
	let baseUrl = config.apis.v3_data+'/simple',
		qs = BuildQS(params);
		
	qs.query_name = 'spotify_discovery_details_timeseries';
	qs.active_milestones = true;
	requestOptions.body = JSON.stringify(qs);

	return fetch(baseUrl, requestOptions).then(res=>res.json());
}

function getSpotifyDiscoveryDetailsTimeseriesStatic() {
	let baseUrl = `${config.apis.sales}/api/static/spotify_discovery_details_timeseries.json`;
	return fetch(baseUrl).then(res=>res.json());
}


